import { useEffect, useState } from 'react'

/** Rộng tối đa của ô tìm, như ô tìm của Google Maps trên desktop. */
export const SEARCH_MAX_WIDTH = 320
/**
 * Chừa lề trái (10px) + cột nút bên phải (toàn màn hình, xoay, người vàng
 * ~40px) + khoảng thở, để ô tìm không đè nút của Google trên khung hẹp.
 */
export const SEARCH_SIDE_GAP = 72

/**
 * Bề rộng ô tìm theo bề rộng THẬT của bản đồ (không theo viewport): bản đồ vẽ
 * thửa trên điện thoại chỉ rộng ~300px nằm trong thẻ, `100vw` sẽ tràn.
 */
export function useSearchWidth(map: google.maps.Map | null): number {
    const [width, setWidth] = useState(SEARCH_MAX_WIDTH)
    useEffect(() => {
        const div = map?.getDiv()
        if (!div) return
        const update = () =>
            setWidth(
                Math.max(
                    0,
                    Math.min(
                        SEARCH_MAX_WIDTH,
                        div.clientWidth - SEARCH_SIDE_GAP,
                    ),
                ),
            )
        update()
        if (typeof ResizeObserver === 'undefined') return
        const ro = new ResizeObserver(update)
        ro.observe(div)
        return () => ro.disconnect()
    }, [map])
    return width
}
